/**
 * Auto Slug Generator
 * 
 * Gera automaticamente slugs para campos baseados em outros campos
 * Usado principalmente para gerar IDs de colunas a partir dos nomes das colunas
 */

document.addEventListener('DOMContentLoaded', function() {
    // Função para converter texto em slug
    function convertToSlug(text) {
        if (!text) return '';
        
        // Converter para minúsculas e remover acentos
        const from = "àáäâãèéëêìíïîòóöôõùúüûñç·/_,:;";
        const to = "aaaaaeeeeiiiiooooouuuunc------";
        
        let newText = text.toLowerCase();
        
        // Substituir caracteres especiais
        for (let i = 0, l = from.length; i < l; i++) {
            newText = newText.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
        }
        
        // Remover caracteres inválidos e substituir espaços por underscores
        return newText
            .replace(/[^a-z0-9 -]/g, '') // remover caracteres inválidos
            .replace(/\s+/g, '_')        // substituir espaços por underscores
            .replace(/-+/g, '_')         // substituir hífens por underscores
            .replace(/^-+/, '')          // remover hífens do início
            .replace(/-+$/, '');         // remover hífens do final
    }
    
    // Função para inicializar os campos com auto-slug
    function initAutoSlugFields() {
        // Encontrar todos os campos com data-auto-slug
        const autoSlugFields = document.querySelectorAll('input[data-auto-slug="true"]');
        
        autoSlugFields.forEach(function(field) {
            const sourceFieldName = field.getAttribute('data-source-field');
            if (!sourceFieldName) return;
            
            // Encontrar o campo fonte no mesmo grupo
            const group = field.closest('.cmb-repeatable-grouping');
            if (!group) return;
            
            const sourceField = group.querySelector(`[name*="[${sourceFieldName}]"]`);
            if (!sourceField) return;
            
            // Adicionar evento para gerar slug quando o campo fonte for alterado
            sourceField.addEventListener('input', function() {
                // Só gerar slug se o campo de destino estiver vazio ou se o usuário não tiver editado manualmente
                if (field.value === '' || field.dataset.autoGenerated === 'true') {
                    const newSlug = convertToSlug(sourceField.value);
                    field.value = newSlug;
                    field.dataset.autoGenerated = 'true';
                }
            });
            
            // Marcar quando o usuário editar manualmente o campo de slug
            field.addEventListener('input', function() {
                field.dataset.autoGenerated = 'false';
            });
            
            // Gerar slug inicial se o campo fonte já tiver valor e o campo de destino estiver vazio
            if (sourceField.value && !field.value) {
                field.value = convertToSlug(sourceField.value);
                field.dataset.autoGenerated = 'true';
            }
        });
    }
    
    // Inicializar os campos existentes
    initAutoSlugFields();
    
    // Reinicializar quando novos grupos forem adicionados (para campos repetíveis)
    document.addEventListener('cmb2_add_row', function() {
        setTimeout(initAutoSlugFields, 100);
    });
});
